export default __webpack_public_path__ + "static/bunda-3-71adfefadf42b94757274ea952a17ca4.jpg";